import { createFileRoute } from '@tanstack/react-router';
import { DocPage } from '@/components/docs/DocPage';
import { apiIntegracaoDocTitle, apiIntegracaoDocDescription, apiIntegracaoDocSections } from '@/content/docs/api-integracao';

export const Route = createFileRoute('/_admin/docs/api-integracao')({
  component: DocsApiIntegracaoPage,
});

function DocsApiIntegracaoPage() {
  return (
    <DocPage
      title={apiIntegracaoDocTitle}
      description={apiIntegracaoDocDescription}
      sections={apiIntegracaoDocSections}
    />
  );
}
